/**
 * Bounded vehicle reference lists (T12 interim, frontend-only). Defined ONCE
 * here; pages import instead of inlining arrays. Mirrors the backend catalog
 * reference data until a server-driven source replaces it.
 */

/** Selectable model years, newest first (2026 → 1990). */
const YEARS = Array.from({ length: 37 }, (_, index) => String(2026 - index));

export { YEARS };
